import { KmapSolvee } from './KmapSolvee';

window.customElements.define('kmap-solvee', KmapSolvee);
